import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { INormalText, ITicket } from '@web/dtos';
import {
  ILayoutAssignmentForm,
  ILayoutAssignmentFormValue,
  ISortimentForm,
} from '../../entities/sortiment-form.entity';
import { Factory } from '../factory';
import { TicketTileFactoryService } from '../ticketTile/ticket-tile-factory.service';

@Injectable({
  providedIn: 'root',
})
export class SortimentFormsFactory extends Factory<ISortimentForm, ITicket[]> {
  private readonly formBuilder: FormBuilder = inject(FormBuilder);
  private readonly ticketTileFactory: TicketTileFactoryService = inject(
    TicketTileFactoryService
  );

  buildForm(
    entities: ITicket[] = [],
    buttonText: INormalText[] = [],
    layoutAssignments: ILayoutAssignmentFormValue[] = []
  ): FormGroup<ISortimentForm> {
    return this.formBuilder.group<ISortimentForm>({
      tickets: this.formBuilder.array(
        entities.map((ticket: ITicket) =>
          this.ticketTileFactory.buildForm(ticket)
        )
      ),
      buttonText:
        this.formBuilder.nonNullable.control<INormalText[]>(buttonText),
      layoutAssignments: this.formBuilder.array(
        layoutAssignments.map((assignment: ILayoutAssignmentFormValue) =>
          this.buildLayoutAssignmentForm(assignment)
        )
      ),
    });
  }

  buildEntity(form: FormGroup<ISortimentForm>): ITicket[] {
    return form.controls.tickets.controls.map(ticketForm =>
      this.ticketTileFactory.buildEntity(ticketForm)
    );
  }

  buildLayoutAssignmentForm(
    assignment: ILayoutAssignmentFormValue
  ): FormGroup<ILayoutAssignmentForm> {
    return this.formBuilder.group<ILayoutAssignmentForm>({
      sortId: this.formBuilder.nonNullable.control(assignment.sortId),
      layoutId: this.formBuilder.control(assignment.layoutId),
      lastEditedAt: this.formBuilder.nonNullable.control(
        new Date(assignment.lastEditedAt)
      ),
    });
  }
}
